module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!./widget.schema.json"));
	}, "validators");
}


//////////////////
// WEBPACK FOOTER
// ./lmm-widget/src/widget/widget.schema.json
// module id = 212
// module chunks = 1